import Modal from './components/modal'

$(document).ready(function () {
  // carousel modal info
  if($('.modal-info').length > 0) {
    const carouselModal = new Glider(document.querySelector('.carousel-modal-info'), {
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: false,
      dots: '#dots-modal-info',
      arrows: {
        prev: '#btn-carousel-prev',
        next: '#btn-carousel-next'
      }
    })

    var popup = $(".modal-info").attr("id");
    const modal = new Modal('#'+popup)

    // code pour ouvrir la modal
    var btn = document.querySelector('#'+popup+'-btn')
    if (btn != null) {
      btn.addEventListener('click', (e) => {
        e.preventDefault()
        modal.open()
        // recalculate carousel
        carouselModal.refresh(true)
        if( ($("#btn-carousel-prev").hasClass('disabled')) && ($("#btn-carousel-next").hasClass('disabled')) ) {
          $(".glider__container-dots").hide();
          $(".modal__footer").hide();
        }
      })
    }
  }
});